import { Component } from 'react';
import { ThemeContext } from '../providers/ThemeProvider';

export default class ThemeContextView<Props = {}, States = {}, SS = any> extends Component<Props, States, SS> {
  static contextType = ThemeContext;

  shouldComponentUpdate(nextProps, nextState) {
    return this.props !== nextProps || nextState !== this.state;
  }

  render() {
    return null;
  }
}
